meedy.controller('meedy.officeCreateController', ['$scope', '$state', '$mdToast', '$mdDialog', '$translate',
    'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.resourceModel', 'meedy.dictionaryModel',
    'meedy.specializationModel', 'meedy.priceListModel', 'meedy.availabilityRuleModel',
    function ($scope, $state, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel, resourceModel,
              dictionaryModel, specializationModel, priceListModel, availabilityRuleModel) {

        function setData() {
            $scope.office = new ResourceMeedyVO();
            $scope.office.address = new AddressMeedyVO();
            $scope.colors = ['#ff0e42', '#1b98f3', '#4cb04f', '#ff9a02', '#a52497', '#919ea8', '#ffef48'];
            $scope.office.color = $scope.colors[0];

            $scope.minutes = availabilityRuleModel.generateAppointmentTimeOptions().map(function(time) { return {value: time, label: time+' min'} });

            $scope.forms = {
                office : null
            };

            $scope.stateList = [];

            $scope.wwwRegExp = /^[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
            $scope.phoneRegExp = '^\\d+$';

            $scope.priceListItems = [];
            $scope.priceListItem = new PriceListItemMeedyVO();

            $scope.specializationList = [];
            $scope.resourcePriceList = new ResourcePriceListMeedyVO();
            $scope.hideAddButton();
            $scope.showBackButton();
            $scope.setTitle('T.MEEDY.UI.APPLICATION.NEW_OFFICE');

            $scope.p1CertificateType = null;
            $scope.alabDiagnostician = null;
        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
            ||  userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
        }

        function setListeners() {
            $scope.$watch('priceListItem.offer', function (newVal) {
                if(newVal) {
                    $scope.onPriceListChange();
                }
            });

            $scope.$on(Event.MEEDY.DICTIONARY.GET_STATES.SUCCESS, function(event, dataPage) {
                $scope.stateList = dataPage.data;
            });

            $scope.$on(Event.MEEDY.USER.GET_MY_DATA.SUCCESS, function(event, wrapper) {
                specializationModel.getDefaultOffersForSpecializationId(wrapper.physicianDetails.firstSpecialization.id);
                specializationModel.getOffersForSpecializationId(wrapper.physicianDetails.firstSpecialization.id);

                if(wrapper.physicianDetails.secondSpecialization) {
                    specializationModel.getDefaultOffersForSpecializationId(wrapper.physicianDetails.secondSpecialization.id);
                    specializationModel.getOffersForSpecializationId(wrapper.physicianDetails.secondSpecialization.id);
                }

                $scope.p1CertificateType = wrapper.medicalPost.p1CertificateType;
                $scope.alabDiagnostician = wrapper.user.alabDiagnostician;
            });

            $scope.$on(Event.MEEDY.SPECIALIZATION.GET_DEFAULT_OFFERS_FOR_SPECIALIZATION_ID.SUCCESS, function(event, list) {
                list.forEach(function(offer){
                    var priceList = new PriceListItemMeedyVO();
                    priceList.offer = offer;
                    priceList.price = 0;
                    $scope.priceListItems.push(priceList);
                })
            });

            $scope.$on(Event.MEEDY.PRICE_LIST.SAVE_PRICE_LIST.SUCCESS, function(event, list) {
                $scope.savingInProgress = false;
                $state.go(Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.LIST);
            });

            $scope.$on(Event.MEEDY.RESOURCE.SAVE.SUCCESS, function(event, offices) {
                $scope.resourcePriceList.pricelistItems = $scope.priceListItems;
                $scope.resourcePriceList.resource = offices;
                userModel.getLoggedUser();
                priceListModel.savePricelist($scope.resourcePriceList);
            });

            $scope.$on(Event.MEEDY.SPECIALIZATION.GET_OFFERS_FOR_SPECIALIZATION_ID.SUCCESS, function(event, list) {
                list.forEach(function(offer){
                    var otherOffer =_.find($scope.specializationList, function(otherOffer) { return otherOffer.id === offer.id; });

                    if(!otherOffer) {
                        $scope.specializationList.push(offer);
                    }
                });
            });

            $scope.$on(Event.MEEDY.RESOURCE.SAVE.SUCCESS, function(event, offices) {
                $state.go(Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.LIST);
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            $scope.onPriceListChange = function() {
                if($scope.priceListItem.offer) {
                    var priceList = angular.copy($scope.priceListItem);

                    var alreadyAdded = _.find($scope.priceListItems, function(priceListItem) { return priceListItem.offer.id === $scope.priceListItem.offer.id; });

                    if(!alreadyAdded) {
                        $scope.priceListItems.push(priceList);
                    }

                    $scope.priceListItem = new PriceListItemMeedyVO();
                }
            };

            $scope.removePriceList = function(priceList) {
                _.remove($scope.priceListItems, function(priceListItem) {
                    return priceList.offer.id == priceListItem.offer.id;
                });
            }
        }

        function setActions() {

            $scope.save = function() {
                $scope.forms.office.$setSubmitted();
                if($scope.forms.office.$valid) {
                    $scope.savingInProgress = true;
                    resourceModel.save($scope.office);
                }
            };

            $scope.getServicePrice = function(index) {
                return $scope.forms.office['servicePrice' + index].$error;
            };

            $scope.isServicePriceValid = function(index) {
                return $scope.forms.office['servicePrice' + index].$touched || $scope.forms.office['servicePrice' + index].$dirty || $scope.forms.office.$submitted;
            }

        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.NEW_OFFICE');
        }

        function initialize() {
            if($scope.isPhysician) {
                dictionaryModel.getStates();
                userModel.getMyData();
            } else {
                $state.go(Constant.STATE.APP.MEEDY.ERROR.ACCESS_DENIED);
            }
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
